import {
  Button,
  PasswordInput,
  Space,
  Title,
  useMantineTheme
} from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { notifications } from "@mantine/notifications";
import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../contexts/auth.context";
import { api } from "../services/api";
import { useApp } from "../contexts/app.context";

export default function Invite() {
  const { companyHost } = useAuth();
  const { configs } = useApp();
  const { key } = useParams();
  const navigate = useNavigate();
  const isMobile = useMediaQuery('(max-width: 900px)');
  const theme = useMantineTheme();

  const [recoverData, setRecoverData] = useState<any>(null);
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPasswordConfirmation] = useState("");

  React.useEffect(() => {
    if (key) {
      api.get(`/auth/recover/${key}`)
        .then(({ data }) => {
          setRecoverData(data);
        })
        .catch(() => {
          notifications.show({ title: "Ops", message: "Token expired, try again", color: 'red' });
          navigate("/")
        })
    }
  }, [key])

  return <div style={{
    backgroundColor: theme.colors.dark[8],
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundAttachment: 'fixed',
    position: 'relative',
    minHeight: '100vh',
    zIndex: 0,
    ...(
      isMobile
        ? {
          padding: 20,
        }
        : {
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          padding: '10vh 20vw',
        }
    )
  }}>
    <div style={{ position: 'absolute', top: 0, bottom: 0, right: 0, left: 0, background: '#00000055', zIndex: -1 }}></div>
    {configs?.image && <div style={{ display: 'flex', margin: '40px 0 10px', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
      <img alt={configs.name} src={configs?.image} style={{ maxHeight: 80, maxWidth: '180px' }} />
    </div>}
    <div style={{ flex: 1, padding: 40 }}>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          api.post("/auth/recover/confirm", {
            uuid: key,
            password,
          })
            .then(() => {
              navigate("/");
              notifications.show({ title: "Recover password", message: "Password updated!", color: 'green' })
            })
            .catch(err => {
              notifications.show({ title: 'Ops', message: 'Token expired', color: 'red' })
            })
        }}
      >
        <Title order={3} mb="lg">Recover Password for {recoverData?.email}</Title>
        <PasswordInput
          mt="md"
          label="Choose a new password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <PasswordInput
          mt="md"
          label="Confirm password"
          value={passwordConfirmation}
          error={passwordConfirmation && passwordConfirmation !== password && "You typed 2 different passwords"}
          onChange={(e) => setPasswordConfirmation(e.target.value)}
        />
        <Space h="xl" />
        <Button
          type="submit"
          mt="xl"
          className="draw-button"
        >
          Recover Password
        </Button>
      </form>
    </div>
    <div style={{ padding: 40 }}>

    </div>
  </div>
};
